import Phaser from 'phaser';

const SKY_TOP = 0x60a5fa;
const SKY_MID = 0xfde68a;
const SKY_BOT = 0xfef3c7;
const MOUNTAIN = 0x7dd3fc;
const MOUNTAIN_DEEP = 0x3b82f6;
const GRASS = 0x16a34a;
const COMMAND_CENTER = 0xfef3c7;
const COMMAND_DOMES = 0xfde047;

export function drawAngelGroveSkyBackground(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
) {
  g.clear();
  const step = Math.max(1, Math.floor(h / 48));
  for (let y = 0; y < h; y += step) {
    const t = y / h;
    let r: number, gC: number, b: number;
    if (t < 0.6) {
      const u = t / 0.6;
      r = lerp((SKY_TOP >> 16) & 0xff, (SKY_MID >> 16) & 0xff, u);
      gC = lerp((SKY_TOP >> 8) & 0xff, (SKY_MID >> 8) & 0xff, u);
      b = lerp(SKY_TOP & 0xff, SKY_MID & 0xff, u);
    } else {
      const u = (t - 0.6) / 0.4;
      r = lerp((SKY_MID >> 16) & 0xff, (SKY_BOT >> 16) & 0xff, u);
      gC = lerp((SKY_MID >> 8) & 0xff, (SKY_BOT >> 8) & 0xff, u);
      b = lerp(SKY_MID & 0xff, SKY_BOT & 0xff, u);
    }
    g.fillStyle((r << 16) | (gC << 8) | b, 1);
    g.fillRect(0, y, w, step + 1);
  }

  g.fillStyle(0xffffff, 0.9);
  g.fillCircle(Math.floor(w * 0.15), Math.floor(h * 0.18), 20);
  g.fillCircle(Math.floor(w * 0.2), Math.floor(h * 0.17), 18);
  g.fillCircle(Math.floor(w * 0.75), Math.floor(h * 0.14), 22);
  g.fillCircle(Math.floor(w * 0.81), Math.floor(h * 0.15), 16);

  g.fillStyle(0xfde047, 1);
  g.fillCircle(Math.floor(w * 0.48), Math.floor(h * 0.2), 24);
  g.fillStyle(0xfef9c3, 0.5);
  g.fillCircle(Math.floor(w * 0.48), Math.floor(h * 0.2), 36);
}

export function drawAngelGroveSilhouette(
  g: Phaser.GameObjects.Graphics,
  w: number,
  h: number,
) {
  const baselineY = Math.floor(h * 0.72);

  g.fillStyle(MOUNTAIN, 1);
  g.fillTriangle(-20, baselineY, Math.floor(w * 0.25), baselineY - Math.floor(h * 0.28), Math.floor(w * 0.45), baselineY);
  g.fillStyle(MOUNTAIN_DEEP, 1);
  g.fillTriangle(Math.floor(w * 0.35), baselineY, Math.floor(w * 0.55), baselineY - Math.floor(h * 0.22), Math.floor(w * 0.72), baselineY);
  g.fillStyle(MOUNTAIN, 1);
  g.fillTriangle(Math.floor(w * 0.6), baselineY, Math.floor(w * 0.82), baselineY - Math.floor(h * 0.3), w + 20, baselineY);

  g.fillStyle(COMMAND_CENTER, 1);
  const ccX = Math.floor(w * 0.82);
  const ccY = baselineY - Math.floor(h * 0.22);
  g.fillRect(ccX - 30, ccY, 60, 70);
  g.fillCircle(ccX - 25, ccY, 15);
  g.fillCircle(ccX, ccY - 8, 20);
  g.fillCircle(ccX + 25, ccY, 15);
  g.fillStyle(COMMAND_DOMES, 1);
  g.fillRect(ccX - 3, ccY - 20, 6, 20);
  g.fillCircle(ccX, ccY - 24, 4);
  g.fillStyle(0x0a0f1f, 0.3);
  g.fillRect(ccX - 8, ccY + 25, 4, 6);
  g.fillRect(ccX + 4, ccY + 25, 4, 6);

  g.fillStyle(GRASS, 1);
  g.fillRect(0, baselineY, w, h - baselineY);
  g.fillStyle(0x15803d, 0.5);
  for (let i = 0; i < 40; i++) {
    const gx = (i / 40) * w;
    const gy = baselineY + 4 + (i % 3) * 8;
    g.fillRect(gx, gy, 8, 2);
  }
}

function lerp(a: number, b: number, t: number): number {
  return Math.round(a + (b - a) * t);
}
